import React, {useState} from 'react'
import Countdown, {zeroPad} from 'react-countdown'
import Affix from 'components/shared/Affix'
import './index.scss'
import {now} from 'lib/dateUtils'

const ReservedBookingTimer = ({reservedBooking, productSelectionReducer}) => {
  const [expired, setExpired] = useState(false)

  const clearReservedBooking = () => {
    setExpired(true)
    productSelectionReducer({type: 'setReservedBooking', reservedBooking: null})
  }

  const countdownRenderer = ({ hours, minutes, seconds, completed }) => {
    let name = ''
    if (reservedBooking && reservedBooking.serviceProvider) {
      name = reservedBooking.serviceProvider.name
    }

    if (completed) {
      return <span>Din valgte tid er utløpt</span>
    } else {
      return <span>Din valgte tid ({name}) utløper om {zeroPad(minutes)}:{zeroPad(seconds)}</span>
    }
  }

  if (reservedBooking || expired) {
    const expiresAt = reservedBooking ? reservedBooking.expiresAt : 0
    return (
      <Affix
        offset={52}
        tagName="aside"
        className="reserved-booking-timer"
      >
        <Countdown
          now={now}
          date={expiresAt}
          renderer={countdownRenderer}
          onComplete={clearReservedBooking}
        />
      </Affix>
    )
  }

  return null
}

export default ReservedBookingTimer
